import { WorkerEmploymentType } from '@types';

export const getFlexWorkerLabel = (
  employmentType: WorkerEmploymentType | undefined,
  partnerName?: string,
  hasCandidateLevel?: boolean,
  isReplacement?: boolean
) => {
  if (partnerName) {
    return partnerName;
  }

  if (hasCandidateLevel) {
    return 'Candidate';
  }

  if (isReplacement) {
    return 'Vervanger';
  }

  if (employmentType === 'FREELANCER') {
    return 'Zelfstandige';
  }

  if (employmentType === 'TEMPWORKER') {
    return 'Uitzendkracht';
  }

  if (employmentType === 'EMPLOYEE') {
    return 'Werknemer';
  }

  return undefined;
};
